import NoMessage from "@/components/noMessage/NoMessage"
import type {
  FreeMaterial,
  FreeMaterialSubject,
} from "@/types/freeMaterialsTypes"
import { Button, Card, Col, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"

import { FaRegCirclePlay } from "react-icons/fa6"
import { MdOutlinePictureAsPdf } from "react-icons/md"
import { useNavigate } from "react-router"

import { FaLock } from "react-icons/fa"
import { toast } from "react-toastify"

export default function FreeMaterialSubject({
  subject,
}: {
  subject: FreeMaterialSubject
}) {
  const { t } = useTranslation()
  if (!subject.free_materials?.length)
    return <NoMessage name={t("noMessages.freeMaterials")} />

  return (
    <Row className="m-auto gy-3">
      {subject.free_materials?.map((material) => (
        <Col xs={12} md={4} key={material.id}>
          <FreeMaterialCard material={material} />
        </Col>
      ))}
    </Row>
  )
}

function FreeMaterialCard({ material }: { material: FreeMaterial }) {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const isPaidMaterial = !material?.link

  return (
    <Card className="rounded-4" style={{ width: "100%" }}>
      <Card.Body>
        <div className="d-flex align-items-start justify-content-between">
          <div className="p-2 bg-danger-subtle rounded-3 me-3">
            {material?.type === "pdf" ? (
              <MdOutlinePictureAsPdf className="text-danger" size={28} />
            ) : (
              <FaRegCirclePlay className="text-danger" size={28} />
            )}
          </div>
          <div
            style={{ paddingInline: "8px" }}
            className="fs-5 fw-bold px-2 rounded-2 bg-light text-secondary"
          >
            {isPaidMaterial && <FaLock />}
          </div>
        </div>
        <Card.Title className="text-dark text-capitalize fs-4 fw-bold my-4">
          {material?.title}
        </Card.Title>
        <Button
          onClick={() => {
            if (isPaidMaterial) {
              toast.info(t("freeMaterialsPage.paidMaterialToast"))
            } else {
              navigate(`${material?.id}`)
            }
          }}
          variant="outline-dark"
          className="w-100 text-center"
        >
          {isPaidMaterial
            ? t("freeMaterialsPage.paidMaterial")
            : material?.type === "pdf"
              ? t("freeMaterialsPage.viewPdf")
              : t("freeMaterialsPage.watchVideo")}
        </Button>
      </Card.Body>
    </Card>
  )
}
